import Carousel from "react-material-ui-carousel";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import styled from "@emotion/styled";
import { Box, IconButton } from "@mui/material";
import ShareIcon from "@icons-rf/property-panel/share-black.svg?react";
import { useNavigate } from "react-router-dom";
import MenuSocial from "@/src-refactor/modules/shared/components/menu-social/MenuSocial";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import useCopyToClipboard from "@/shared/hooks/use-copy-to-clipboard";
import FsLightbox from "fslightbox-react";
import Logo from "@icons-rf/maxcore-ballow.svg?react";
import { C_PROPERTIES_STATUS } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";

const CarouselImages = () => {
  const navigate = useNavigate();
  const [value, copy, notification] = useCopyToClipboard();
  const [toggler, setToggler] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const {
    PROPERTY_DETAIL: { principalData }
  } = useRealEstateDetailContext();

  const handleCopyOnClick = () => {
    copy(principalData.id.toString())
      .then(() => toast.success("Copiado al portapapeles"))
      .catch(() => toast.error("Error al copiar"));
  };

  const isActiveProperty =
    principalData.property_status.id === C_PROPERTIES_STATUS.ACTIVE.id;

  const onOpenMenuNetworks = () => {
    document.getElementById("menu-social-item")?.click();
  };
  const handleImageClick = (index: number) => {
    setSelectedIndex(index);
    setToggler(!toggler);
  };
  useEffect(() => {
    const containerNavButtons = document.querySelector(".nav-btn")?.parentElement;
    if (containerNavButtons) {
      containerNavButtons.classList.add("container-buttons");
    }
  }, []);

  useEffect(() => {
    const btn = document.querySelector(
      '[aria-label="carousel indicator 1"'
    ) as HTMLButtonElement;
    const btn2 = document.querySelector(
      '[aria-label="carousel indicator 2"'
    ) as HTMLButtonElement;
    btn2?.click();
    btn?.click();
  }, []);

  return (
    <Container>
      {principalData.pictures.length === 0 && (
        <EmptyPicture>
          <Logo />
        </EmptyPicture>
      )}

      {principalData.pictures.length > 0 && (
        <Carousel
          index={selectedIndex}
          autoPlay={false}
          className="carousel"
          animation="slide"
          navButtonsProps={{ className: "nav-btn" }}
          navButtonsAlwaysVisible
          indicatorContainerProps={{
            style: { zIndex: 1, top: "-45px", position: "relative" }
          }}
          indicatorIconButtonProps={{
            className: "indicator-container"
          }}
          fullHeightHover={false}
        >
          {principalData.pictures.map((item, index) => (
            <ContainerImage key={index}>
              <Image
                src={item}
                alt={`Imagen #${index + 1}`}
                onClick={() => handleImageClick(index)}
              />
            </ContainerImage>
          ))}
        </Carousel>
      )}

      {isActiveProperty && (
        <ShareButton size="small" disableRipple onClick={onOpenMenuNetworks}>
          <ShareIcon />
        </ShareButton>
      )}

      <MenuNetworks>
        <MenuSocial
          bussinesType={principalData?.business_type}
          propertyId={principalData?.id?.toString()}
          propertyType={principalData?.realstate_type}
          sector={principalData?.location}
        >
          <div id="menu-social-item"></div>
        </MenuSocial>
      </MenuNetworks>

      <IdIcon onClick={handleCopyOnClick}>ID: {principalData.id}</IdIcon>

      <FsLightbox
        toggler={toggler}
        sourceIndex={selectedIndex}
        sources={principalData.pictures.map((item, index) => (
          <img src={item} key={index} />
        ))}
      />
    </Container>
  );
};
export default CarouselImages;

const NavBarButton = styled(Box)`
  position: absolute;
  top: 0px;
  left: 0px;
  transform: translate(0%, -50%);
  display: flex;
  align-items: center;
  z-index: 1000000;
  width: 30%;
  height: 60px;
  & .MuiButtonBase-root {
    background-color: var(--m-color-blue-03);
    svg {
      color: white;
    }
  }
`;

const EmptyPicture = styled.div`
  width: 100%;
  height: auto;
  min-height: 60vh;
  background: var(--m-color-gray-01);
  border-radius: 20px 20px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  svg {
    width: 50%;
    height: 50%;
  }
`;

const Container = styled.div`
  position: relative;
  .carousel {
    width: 100%;
    height: 60vh;
  }
  .container-buttons {
    &:hover {
      .nav-btn {
        background: var(--color-blue-main);
        opacity: 1;
      }
    }
  }
  .nav-btn {
    background: var(--color-blue-main);
    opacity: 0.5;
    &:hover {
      background: var(--color-blue-main) !important;
      opacity: 1 !important;
    }
    width: 30px;
    height: 30px;
  }
`;

const ContainerImage = styled.div`
  width: 100%;
  height: 60vh;
  border-radius: 0 20px 0 0;
  position: relative;
  img {
    object-fit: cover;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 20px 20px 0 0;
  cursor: pointer;
`;

const prefixStylesButton = `
    width: 35px;
    height: 35px;
    position: absolute;
    background: #FFFFFF;
    cursor: pointer;
    z-index: 1100;
    svg{
      color: var(--m-color-blue-03);
      fill: var(--m-color-blue-03);
      width: 25px;
      height: 25px;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    
`;

const ShareButton = styled(IconButton)`
  ${prefixStylesButton}
  top: 10px;
  right: 10px;
  padding-left: 0.9px;
`;

const BackButton = styled(IconButton)`
  ${prefixStylesButton}
  top: 10px;
  left: 10px;
`;

const IdIcon = styled.div`
  background: var(--color-blue-main);
  position: absolute;
  cursor: pointer;
  bottom: 0px;
  right: 0px;
  padding-left: 20px;
  padding-right: 15px;
  color: white;
  letter-spacing: 1px;
  border-radius: 0.9375rem 0 0 0;
  font-family: var(--ff-inter);
  font-weight: 600;
  font-size: 0.9375rem;
  height: 35px;
  display: flex;
  align-items: center;
  z-index: 1100;
`;

const MenuNetworks = styled.div`
  position: absolute;
  top: 35px;
  right: 5px;
  padding-left: 0.9px;
`;
